export default {
    baseStyle: {
        heading: {
            fontFamily: 'UniversLTStd, Arial, sans-serif'
        },
        errorButtonContainer: {
            width: 'full',
            display: 'flex',
            justifyContent: 'center'
        },
        ButtonStyle: {
            width: 'auto'
        }
    }
}
